import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowRight,
  faCakeCandles,
  faUsers,
  faRing,
  faPeopleGroup
} from '@fortawesome/free-solid-svg-icons';
import backgroundImage from '../Images/fundoUniversoTempo.png';
import backgroundImageMobile from '../Images/cardMobileTempo.png';
import cardImage from '../Images/cardUniversoTempo.png';
import '../CSS/DesafiosChallenges.css';
import '../CSS/HomeInicio.css';

const experiences = [
  {
    icon: faCakeCandles,
    title: 'Birthday Parties',
    description: 'Celebrate in a different and unforgettable way!',
    to: '/birthday-parties'
  },
  {
    icon: faUsers,
    title: 'Team Building',
    description: 'Strengthen your team with fun and strategy.',
    to: '/team-building'
  },
  {
    icon: faRing,
    title: 'Bachelorette Parties',
    description: 'An epic send-off no one will forget!',
    to: '/bachelorette-party'
  },
  {
    icon: faPeopleGroup,
    title: 'Groups & Families',
    description: 'Adventure for all ages.',
    to: '/loretochallenge'
  }
];

const Homepage = () => {
  const handleClick = (desafioId) => {
    localStorage.setItem('selectedChallenge', desafioId);
  };

  return (
    <div className="er-homePage">
      <section className="er-hero" aria-label="Escape Room Bragança">
        <picture className="er-heroMedia">
          <source media="(max-width: 600px)" srcSet={backgroundImageMobile} />
          <img src={backgroundImage} alt="" className="er-heroImg" />
        </picture>

        <div className="er-heroOverlay">
          <div className="er-container er-heroInner">
            <p className="er-homeHeroKicker">Ready for the challenge?</p>
            <h1 className="er-heroTitle">Escape Room Bragança</h1>

            <div className="er-heroFeature">
              <img src={cardImage} className="er-heroFeatureImg" alt="" />
              <div className="er-heroFeatureText">
                <div className="er-heroKicker">Featured</div>
                <div className="er-heroFeatureTitle">The Time Traveller</div>
                <div className="er-heroFeatureSub">What mysteries does he hide?</div>
              </div>
            </div>

            <div className="er-heroCtas">
              <Link
                className="er-button er-button-primary"
                to="/bookings"
                onClick={() => handleClick('3')}
              >
                Book now
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="er-homeExperiences" aria-label="Experiences">
        <div className="er-container">
          <div className="er-homeExperiencesHead">
            <h2 className="er-homeExperiencesTitle">Choose your experience</h2>
            <p className="er-homeExperiencesSubtitle">
              We have the perfect experience for every occasion.
            </p>
          </div>

          <div className="er-homeExperiencesGrid">
            {experiences.map((item) => (
              <Link key={item.title} to={item.to} className="er-homeExperienceCard">
                <div className="er-homeExperienceIconTitleDiv">
                  <FontAwesomeIcon icon={item.icon} className="er-homeExperienceIcon" />
                  <h3 className="er-homeExperienceTitle">{item.title}</h3>
                </div>
                <p className="er-homeExperienceDesc">{item.description}</p>
                <span className="er-homeExperienceLink">
                  Learn more <FontAwesomeIcon icon={faArrowRight} />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Homepage;
